/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";

export type SecureCreator = <T>(setState: React.Dispatch<React.SetStateAction<T>>) => React.Dispatch<React.SetStateAction<T>>;
export type AbortableEffectCallback = (
    secure: SecureCreator
) => void | (() => void | undefined);

export default class Secure {
    public static useEffect(effect: AbortableEffectCallback, deps?: React.DependencyList) {
        React.useEffect(() => {
            let aborted = false;

            const secure = <T>(setState: React.Dispatch<React.SetStateAction<T>>) => {
                if (aborted) {
                    return (value: React.SetStateAction<T>) => {}
                }

                return setState
            };

            const cleanup = effect(secure);

            return () => {
                aborted = true;
                if (typeof cleanup === "function") {
                    cleanup();
                }
            };
        }, deps);
    }
}
